import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import map from 'lodash/map';

// import range from 'lodash/range';
import sampleSize from 'lodash/sampleSize';
import shuffle from 'lodash/shuffle';
import slice from 'lodash/slice';
import Image from '../components/Image';
import WorkNav from '../components/WorkNav';
import Loader from '../components/Loader';
import Animated from '../components/Animated';

import {
  wrapper,
  fullWidth,
  halfWidth,
  thirdWidth,
  // quarterWidth,
  imageWrapper,
  textContainer,
} from '../styles';
import BigList from '../components/BigList';

const row1 = (image, index) => {
  return (
    <div {...fullWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

const row2 = (image, index) => {
  return (
    <div {...halfWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

const row3 = (image, index) => {
  return (
    <div {...thirdWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

// const row4 = (image, index) => {
//   return (
//     <div {...quarterWidth} key={`image-${index}`}>
//       <Image sources={image} />
//     </div>
//   );
// };

class Blom extends Component {
  constructor(props) {
    super(props);
    this.state = { set1: [], set2: [] };
  }

  componentWillMount() {
    this.props.load();
    this.props.loadTheme();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.blom && nextProps.blom.images && !this.state.set1.length) {
      const { images } = nextProps.blom;
      let set1 = slice(images, 1, 400);
      set1 = sampleSize(shuffle(set1), 25);
      let set2 = slice(images, 401, images.length - 1);
      set2 = sampleSize(shuffle(set2), 25);
      this.setState({ set1, set2 });

      // traiditional, fluidity, quarter-circle, and mountain
      const traditionalSet = [
        4, 5, 7, 9, 12, 18, 26, 27, 29, 33, 34, 37, 38, 40, 44, 50, 56, 61, 65,
        66, 67, 83, 90, 91, 92,
      ];
      const fluiditySet = [
        3, 10, 11, 15, 19, 21, 23, 28, 32, 35, 43, 48, 63, 86, 94, 96, 100,
      ];
      const qCircleSet = [13, 20, 31, 51, 54, 59, 60, 87, 95, 97, 104, 115];
      const mountainSet = [16, 39, 41, 47, 84];
      const innvortisSet = [36, 49, 53, 88, 99];
      const skipsSet = [22, 57, 58, 62, 74, 327, 331, 348, 461, 504];
      const swirlSet = [52, 368, 391];
      // const prideSet = [79];
      const mirrorSet = [82, 105, 332, 380, 421, 465];
      const monochromeSet = [2, 102, 310, 528];
      const hueySet = [107, 108, 114, 119];
      const quiltedSet = [122, 125, 128, 129];
      const triangleSet = [299, 303, 308, 319, 321, 322, 323, 338, 339];
      const outlineSet = [309, 330, 352, 355, 376];
      // const squareSet = [311, 316, 328, 361];

      const randomTraditionalIndex = Math.floor(
        Math.random() * traditionalSet.length,
      );
      const randomTraditional =
        images[traditionalSet[randomTraditionalIndex] - 1];

      const randomFluidityIndex = Math.floor(
        Math.random() * fluiditySet.length,
      );
      const randomFluidity = images[fluiditySet[randomFluidityIndex] - 1];

      const randomQCircleIndex = Math.floor(Math.random() * qCircleSet.length);
      const randomQCircle = images[qCircleSet[randomQCircleIndex] - 1];

      const randomMountainIndex = Math.floor(
        Math.random() * mountainSet.length,
      );
      const randomMountain = images[mountainSet[randomMountainIndex] - 1];

      const randomInnvortisIndex = Math.floor(
        Math.random() * innvortisSet.length,
      );
      const randomInnvortis = images[innvortisSet[randomInnvortisIndex] - 1];

      const randomHueyIndex = Math.floor(Math.random() * hueySet.length);
      const randomHuey = images[hueySet[randomHueyIndex] - 1];

      const randomMonochromeIndex = Math.floor(
        Math.random() * monochromeSet.length,
      );
      const randomMonochrome = images[monochromeSet[randomMonochromeIndex] - 1];

      const randomQuiltedIndex = Math.floor(Math.random() * quiltedSet.length);
      const randomQuilted = images[quiltedSet[randomQuiltedIndex] - 1];

      // const randomPrideIndex = Math.floor(Math.random() * prideSet.length);
      // const randomPride = images[prideSet[randomPrideIndex] - 1];

      const randomSwirlIndex = Math.floor(Math.random() * swirlSet.length);
      const randomSwirl = images[swirlSet[randomSwirlIndex] - 1];

      const randomMirrorIndex = Math.floor(Math.random() * mirrorSet.length);
      const randomMirror = images[mirrorSet[randomMirrorIndex] - 1];

      const randomSkipsIndex = Math.floor(Math.random() * skipsSet.length);
      const randomSkips = images[skipsSet[randomSkipsIndex] - 1];

      const randomTriangleIndex = Math.floor(
        Math.random() * triangleSet.length,
      );
      const randomTriangle = images[triangleSet[randomTriangleIndex] - 1];

      const randomOutlineIndex = Math.floor(Math.random() * outlineSet.length);
      const randomOutline = images[outlineSet[randomOutlineIndex] - 1];

      // const randomSquareIndex = Math.floor(Math.random() * squareSet.length);
      // const randomSquare = images[squareSet[randomSquareIndex] - 1];

      const colorsList = {
        huey: {
          title: 'Huey',
          slug: 'huey',
          excerpt:
            'The huey color theme selects a random hue and modulates the color over time.',
          headerImage: randomHuey,
          images: [randomHueyIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        monochrome: {
          title: 'Monochromatic',
          slug: 'monochromatic',
          excerpt:
            'Sometimes the Huey theme will have a very small threshold of color variation, creating a monochrome image.',
          headerImage: randomMonochrome,
          images: [randomMonochromeIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        quilted: {
          title: 'Quilted',
          slug: 'quilted',
          excerpt:
            'The quilted color theme assigns random colors to each particle from a collection of predefined sets.',
          headerImage: randomQuilted,
          images: [randomQuiltedIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        // pride: {
        //   title: 'Pride',
        //   slug: 'pride',
        //   excerpt:
        //     'In very rare cases, hues can cycle through the entire spectrum creating a beautiful rainbow.',
        //   headerImage: randomPride,
        //   images: [randomPrideIndex],
        //   colorTheme: { base: '#121212', hilite: '#df0000' },
        // },
      };

      const presetsList = {
        traditional: {
          title: 'Traditional',
          slug: 'traditional',
          excerpt: 'The classic Blóm.',
          headerImage: randomTraditional,
          images: [randomTraditionalIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        fluidity: {
          title: 'Fluidity',
          slug: 'fluidity',
          excerpt:
            'Fluidity is similar to Traditional, but the Blóm is drawn with the lines going out from the center instead of around the center.',
          headerImage: randomFluidity,
          images: [randomFluidityIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        mountain: {
          title: 'Mountain',
          slug: 'mountain',
          excerpt:
            'Mountains are Blóms that are drawn from the side. The center of a Blóm is the top of the image, and it grows down and out along the canvas.',
          headerImage: randomMountain,
          images: [randomMountainIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        qCircle: {
          title: 'Quarter Circle',
          slug: 'qCircle',
          excerpt:
            'Quarter circle is a Blóm zoomed in on the bottom right quadrant.',
          headerImage: randomQCircle,
          images: [randomQCircleIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        innvortis: {
          title: 'Innvortis',
          slug: 'innvorits',
          excerpt:
            'Innvortis is a zoomed in Blóm, as if you are looking closely at it.',
          headerImage: randomInnvortis,
          images: [randomInnvortisIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
      };

      const renderersList = {
        triangles: {
          title: 'Triangles',
          slug: 'triangles',
          excerpt:
            'Drawing triangles between particles and their neighbors yields visually interesting results.',
          headerImage: randomTriangle,
          images: [randomTriangleIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        outlines: {
          title: 'Outlines',
          slug: 'outlines',
          excerpt:
            'Shapes can be outlined, and the outline thickness can either be variable or static.',
          headerImage: randomOutline,
          images: [randomOutlineIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        swirls: {
          title: 'Swirls',
          slug: 'swirls',
          excerpt:
            'Particles can be drawn in a continuous line, creating pleasant-looking lines that appear hand-drawn.',
          headerImage: randomSwirl,
          images: [randomSwirlIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        skips: {
          title: 'Skips',
          slug: 'skips',
          excerpt:
            'Particles can be occasionally not drawn, creating negative space in the rendering.',
          headerImage: randomSkips,
          images: [randomSkipsIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
        mirror: {
          title: 'Mirror',
          slug: 'mirror',
          excerpt:
            'When the forces on a Blóm prevent it from filling the canvas, the Blóm is repeated in a circle around the original shape.',
          headerImage: randomMirror,
          images: [randomMirrorIndex],
          colorTheme: { base: '#121212', hilite: '#df0000' },
        },
      };

      this.setState({
        randomTraditional,
        randomTraditionalIndex,
        randomFluidity,
        randomFluidityIndex,
        randomQCircleIndex,
        randomQCircle,
        randomMountainIndex,
        randomMountain,
        randomInnvortisIndex,
        randomInnvortis,
        randomHueyIndex,
        randomHuey,
        randomQuilted,
        randomQuiltedIndex,
        randomMonochrome,
        randomMonochromeIndex,
        colorsList,
        presetsList,
        renderersList,
      });
    }
  }

  render() {
    const { blom } = this.props;
    if (!blom || !blom.images) {
      return <Loader />;
    }

    const allImages = blom.images;
    const { set1, set2, colorsList, presetsList, renderersList } = this.state;
    const { prev, next } = this.props;
    return (
      <div>
        <Helmet
          title="Blóm by lucastswick"
          description="Blóm is a generative art series that draws abstract roses."
          meta={[
            {
              property: 'og:image:url',
              content: `https://generativeartist.com${allImages[0][2].srcSet}`,
            },
            {
              property: 'twitter:image',
              content: `https://generativeartist.com${allImages[0][2].srcSet}`,
            },
          ]}
        />
        <div {...textContainer}>
          <Animated as="h2">Blóm</Animated>
          <Animated delay={150}>
            Blóm is a generative art series that explores the tension between
            internal and external forces.
          </Animated>
          <Animated delay={300}>
            Blóm is composed of many particles that all have intent - they want
            to move a certain direction - but external forces push them around.
            Sometimes the particles continue on their desired journey, sometimes
            they are forced onto another path, and these wanderings, over time,
            compose images.
          </Animated>
          <Animated delay={450}>
            Released on the now-defunct platform gen.art, the series is
            long-form generative, meaning a piece is not created until someone
            purchases it. At that moment, a one-of-a-kind artwork is generated
            based on the unique signature of the buyer. Although I wrote the
            algorithm, no one, not even me, knows exactly what my algorithm will
            produce.
          </Animated>
          <div {...imageWrapper}>{row1(allImages[0], 0)}</div>
          <Animated>
            Above is the very first image that was minted. Minting is the
            process of a buyer purchasing a single piece of the series. When the
            transaction occurs, a unique token is passed to my algorithm which
            then creates the one-of-a-kind art.
          </Animated>
          <Animated>
            Roughly 1000 pieces have been minted so far, and I'm very pleased to
            see the variety of the collection and the reaction from the
            community.
          </Animated>
          <Animated>
            Here is a randomly selected sampling of images (you can refresh to
            see another set):
          </Animated>
        </div>
        <div {...wrapper}>
          {map(set1, (image, index) => {
            if (index % 5 === 0) {
              const image2 = set1[index + 1];
              return (
                <Fragment key={`group-${index}`}>
                  {row2(image, index)}
                  {row2(image2, index + 1)}
                </Fragment>
              );
            } else if (index % 5 === 1) {
              return null;
            } else {
              return row3(image, index);
            }
          })}
        </div>
        <div {...textContainer}>
          <Animated as="h2">How was Blóm created?</Animated>
          <Animated>
            The first iteration of Blóm was created for a generative artist
            trading card series released in 2015. At the time, javascript was
            not performant enough to render high-resolution images in the
            browser, so I used{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://openframeworks.cc"
            >
              openframeworks
            </a>{' '}
            to generate the 150 pieces of work that I eventually released as a
            limited print series.
          </Animated>
          <Animated>
            With the advent of NFTs, generative art suddenly became quite
            popular, and I was eager to revisit the project with all the new
            ideas and learnings I've had in the past 6 years. Specifically, I
            focused on opportunities around color, perspective, and render
            methods.
          </Animated>
        </div>
        <div {...textContainer}>
          {/* <div {...imageWrapper}>{row1(allImages[933], 933)}</div> */}
          <Animated as="h2">Colors</Animated>

          <Animated>
            The colors are either <i>quilted</i> or <i>huey</i>. Quilted
            indicates each particle has a color selected from a list of preset
            color families. Huey means a random hue is chosen, and each
            particle's color can be modulated towards another hue over the
            course of the drawing.
          </Animated>
        </div>
        <div {...wrapper}>
          <BigList items={colorsList} />
        </div>
        <div {...textContainer}>
          <Animated as="h2">Perspectives</Animated>
          <Animated>
            In addition to lots of color variation, Blóms can also be drawn from
            different perspectives.
          </Animated>
        </div>
        <div {...wrapper}>
          <BigList items={presetsList} />
        </div>
        <div {...textContainer}>
          <Animated as="h2">Render Methods</Animated>
          <Animated>
            The final component of creating variation within the collection is
            the employment of render methods, which change how each particle's
            path is drawn.
          </Animated>
        </div>
        <div {...wrapper}>
          <BigList items={renderersList} />
        </div>
        <div {...textContainer}>
          <Animated as="h2">Even more Blóms!</Animated>
        </div>
        <div {...wrapper}>
          {map(set2, (image, index) => {
            if (index % 5 === 0) {
              const image2 = set2[index + 1];
              return (
                <Fragment key={`group-${index}`}>
                  {row2(image, index)}
                  {row2(image2, index + 1)}
                </Fragment>
              );
            } else if (index % 5 === 1) {
              return null;
            } else {
              return row3(image, index);
            }
          })}
        </div>
        <div {...textContainer}>
          <Animated as="h2">Reactions</Animated>
          <Animated>
            Blóm has received amazing feedback from the community, particularly
            on twitter and the gen.art discord. Thank you to everyone who has
            supported the project, shared it, and even{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://twitter.com/liz_fitzg/status/1447314841895518210?s=20"
            >
              made it their profile pic
            </a>
            !
          </Animated>
          <Animated as="h2">Technical Details</Animated>
          <Animated>
            Blóm is written in javascript with zero dependencies, meaning as
            long as the etherium blockchain is running the work will be
            available. It's probably the first project I've ever worked on that
            would still operate even if Amazon went down.
          </Animated>
          <Animated as="h2">I'd like one too please</Animated>
          <Animated>
            Want your very own Blóm? You'll need a{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://gen.art"
            >
              gen.art
            </a>{' '}
            membership, or you can buy existing pieces on{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://opensea.io/collection/gen-art-drop?search[sortAscending]=false&search[sortBy]=LAST_SALE_PRICE&search[stringTraits][0][name]=Artist&search[stringTraits][0][values][0]=lucastswick"
            >
              OpenSea
            </a>
            .
          </Animated>
        </div>

        <WorkNav prev={prev} next={next} />
      </div>
    );
  }
}

export default Blom;



// WEBPACK FOOTER //
// ./src/pages/Blom.js